import React from "react";
import { observer } from "mobx-react-lite";
import "./Premium.scss";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import authStore from "../../stores/AuthStore";
import { UserRoles } from "../../stores/AuthStore/types";
import useTranslation from "../../hooks/useTranslation";

const Premium = observer(() => {
  const { t } = useTranslation();
  return (
    <Box className="container">
      <Typography variant="h5" className="pt">
        {t("premiumPageTitle")}
      </Typography>
      <Typography sx={{ margin: { xs: "16px 0", sm: "24px 0" } }}>
        {authStore.userHasRole(UserRoles.LAWYER) && t("premiumPageSubtitle")}
      </Typography>
    </Box>
  );
});

export default Premium;
